<template>
  <div id="pageContent">
    <div class="borderBox">
      <div class="fl headFinder">
        <div>
          <label >Дата от</label>
          <input type="date" v-model="SendData.DtBegin">
        </div>
        <div>
          <label >Дата до</label>
          <input type="date" v-model="SendData.DtEnd">
        </div>
        <div class="button" v-on:click="findRequest">Показать</div>
      </div>
      <hr>
      <div v-if="isLoading">Идет загрузка подождите</div>
      <div v-if="cooldStart == false && requestList.length == 0 && isLoading == false">Нет результата по данному запросу</div>
      <ul v-else id="result_table" class="finderRequest myrequest">
        <li v-if="requestList.length > 0">
          по данному запросу найдено: {{requestFindTotal}}
        </li>
        <li id="result_head" v-if="requestList.length > 0">
          <p>Номер заявки</p>
          <p>Фио Клиента</p>
          <p>Дата</p>
          <p>Статус</p>
        </li>
        <li v-for="request in requestSort" class="fl">
          <p>{{request.x_id}}</p>
          <p>{{request.fio}}</p>
          <p>{{request.timestamp}}</p>
          <p>{{request.x_status}}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

  function formatDate(date){
    var values = [date.getDate(), date.getMonth() + 1];
    for (var id in values) {
      values[ id ] = values[ id ].toString().replace(/^([0-9])$/, '0$1');
    }
    return date.getFullYear() + '-' + values[1] + '-' + values[0];
  }

  var dtDateDesc = function (d1, d2) {
    return (d1.timestamp.toLowerCase() < d2.timestamp.toLowerCase()) ? 1 : -1;
  }

  export default {
    name: "myRequest",
    data: function(){
      return {
        SendData:{
          DtBegin:'',
          DtEnd:''
        },
        requestList: [],
        cooldStart: true,
        isLoading: false
      }
    },
    mounted(){
      var date = new Date();
      date.setDate(date.getDate() + 1);
      this.SendData.DtEnd = formatDate(date);
      date.setDate(date.getDate() - 31);
      this.SendData.DtBegin = formatDate(date);
      this.getRequestList();
    },
    computed: {
      requestSort() {
        return this.requestList.sort(dtDateDesc);
      },
      requestFindTotal(){
        return this.requestList.length;
      }
    },
    methods:{
      getRequestList:function(){
        this.$myApi.singleRequest({
          action:'Operator_myRequest',
          DtEnd: this.SendData.DtEnd,
          DtBegin: this.SendData.DtBegin,
        })
        .then((resp) => {
          this.requestList = resp;
        })
        .catch((resp) => console.log(resp));
      },
      findRequest:function(){
        this.getRequestList();
      }
    }
  }
</script>

<style scoped>
  ul,li{list-style: none;margin: 0;
    padding: 0;}
.headFinder{align-items: center;}
#result_table li{display: flex;align-items: stretch;justify-content: start;border:1px solid #c2c2c2;background: rgba(217, 243, 220, 0.52);font-size: 14px;line-height: 1.1;text-transform: lowercase;}
#result_table li:nth-child(2n){background: white;}
#result_table li p{border-left: 1px solid #c2c2c2;padding: 4px;}
#result_table li p:first-child{border-left: 0 solid #c2c2c2;}

#result_table.finderRequest p:nth-child(1){width: 7%;}
#result_table.finderRequest p:nth-child(2){width: 12%;}
#result_table.finderRequest p:nth-child(3){width: 8%;}
#result_table.finderRequest p:nth-child(4){width: 8%;}
#result_table.finderRequest p:nth-child(5){width: 8%;}
#result_table.finderRequest p:nth-child(6){width: 8%;}
#result_table.finderRequest p:nth-child(7){width: 8%;}
#result_table.finderRequest p:nth-child(8){width: 8%;}
#result_table.finderRequest p:nth-child(9){width: 7%;}
#result_table.finderRequest p:nth-child(10){width: 16%;}

.transformFio{text-transform: capitalize}


#result_table.finderRequest.myrequest p:nth-child(1){width: 20%;}
#result_table.finderRequest.myrequest p:nth-child(2){width: 20%;}
#result_table.finderRequest.myrequest p:nth-child(3){width: 20%;}
#result_table.finderRequest.myrequest p:nth-child(4){width: 20%;}
</style>
